// Services
import storeCreditService from '@/app/services/main/store-credit/store-credit-service.js';
import CartService from '@/app/services/main/cart/cart-service.js';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

// Event Bus
import EventBus from '@/app/bus/event-bus.js';

export default {
	name: 'StoreCreditPreview',
	props: {
			petId: {
					type: Number,
					required: true
			}
	},
	data() {
			return {
					storeCredit: 0,
					availableStoreCredit: 0,
					isAPILoading: true,
					showTooltip: false
			}
	},
	created() {
		EventBus.$on('updateStoreCreditPreview', this.getCartList )
	},
	destroyed() {
		EventBus.$off('updateStoreCreditPreview', this.getCartList )
	},
	mounted() {
		this.getStoreCredit();
	},
	methods: {
		async getCartList() {
			try {
				const res = await CartService.getCart(this.petId, { f_type: "products" })
				if (res.status === STATUS_CODES.SUCCESS) {
					this.isAPILoading = false;	
				}	
			} catch (error) {
				this.showAPIErrorToast('', error);	
			}

		},
		async getStoreCredit() {
			try {
				const res = await storeCreditService.getStoreCredit()
				if (res.status === STATUS_CODES.SUCCESS) {
					this.storeCredit = res.data.data.amount;
					this.getCartList();
				}	
			} catch (error) {
				this.showGenericErrorToast();	
			}
		},
	}
}